import React from 'react';
import CCMRSSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';

export default function Page07({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = CCMRSSyle();
	return (
		<div style={style.outerStyle()}>
			<RoundScreen
				title='Run 3 - 4 Rounds'
				isNumbered={true}
				rounds={[
					[
						{
							header: 'Type',
							value: 'Alpa',
						},
						{
							header: 'C.C.M.R’s',
							value: 'DEADLIFTS',
						},
						{
							header: 'REPS/Min',
							value: '6-8',
						},
						{
							header: 'WEIGHT LEVE',
							value: 'Mild',
						},
					],
					[
						{
							header: 'Type',
							value: 'Beta',
						},
						{
							header: 'C.C.M.R’s',
							value: 'WIDE-GRIP PULLUPS',
						},
						{
							header: 'REPS/Min',
							value: '10',
						},
						{
							header: 'WEIGHT LEVEL',
							value: 'BodyWeight',
						},
					],
					[
						{
							header: 'Type',
							value: 'Beta',
						},
						{
							header: 'C.C.M.R’s',
							value: 'ASSAULT BIKE',
						},
						{
							header: 'REPS/Min',
							value: '2min',
						},
						{
							header: 'WEIGHT LEVEL',
							value: 'Intense Cardio',
						},
					],
					[
						{
							header: 'Type',
							value: 'Beta',
						},
						{
							header: 'C.C.M.R’s',
							value: 'RESISTANCE BANDS ROWS',
						},
						{
							header: 'REPS/Min',
							value: '12',
						},
						{
							header: 'WEIGHT LEVEL',
							value: 'Light ',
						},
					],
				]}
			/>
			<p style={style.takeABreakTextStyle()}>Take a 1 - 2 minute break</p>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
